const registeredItems = [];

const _handleVariation = function(variationId, variationData, store)
{
    store.state.overlayItemId = 0;

    if(!variationData || !variationData.documents || variationData.documents.length <= 0)
    {
        return;
    }

    const itemId = variationData.documents[0].data.item.id;
    store.state.variations[variationId] = variationData;
    store.state.overlayItemId = itemId;

    if(registeredItems.indexOf(itemId) >= 0)
    {
        store.commit(itemId + "/setVariation", variationData);
    }
    else
    {
        store.dispatch("initVariation", variationData);
        registeredItems.push(itemId);
    }

    if(!!store.state.attributeMaps[itemId])
    {
        _handleAttributeMap(itemId, variationId, store.state.attributeMaps[itemId], store)
    }
    else
    {
        $.ajax(
            "/rest/io/variations/map?itemId=" + itemId,
            {
                method:     "GET",
                dataType:   "json"
            })
            .done(function(response)
            {
                _handleAttributeMap(itemId, variationId, response.data, store);
            })
            .fail(function(err)
            {
                console.error(err);
            });
    }
};

const _handleAttributeMap = function(itemId, variationId, attributeMap, store)
{
    store.state.attributeMaps[itemId] = attributeMap;
    store.dispatch(itemId + "/variationSelect/setVariationSelect", {
        itemId:             itemId,
        attributes:         attributeMap.attributes,
        variations:         attributeMap.variations,
        initialVariationId: variationId,
        isPleaseSelectOption: false
    });

    if(!!store.state.onLoadingDone && typeof store.state.onLoadingDone === "function")
    {
        store.state.onLoadingDone();
    }
};

export default {
    state: {
        onLoadingStart: null,
        onLoadingDone: null,
        overlayItemId: 0,
        variations: {},
        attributeMaps: {}
    },

    mutations: {
        setOnLoadingStart(state, callback)
        {
            state.onLoadingStart = callback;
        },

        setOnLoadingDone(state, callback)
        {
            state.onLoadingDone = callback;
        }
    },

    actions: {
        showOverlay(store, variationId)
        {
            if(!!store.state.onLoadingStart && typeof store.state.onLoadingStart === "function")
            {
                store.state.onLoadingStart();
            }

            if(!!store.state.variations[variationId])
            {
                setTimeout(() => {
                    _handleVariation(variationId, store.state.variations[variationId], store);
                }, 1);
            }
            else
            {
                $.ajax(
                    "/rest/io/variations/" + variationId,
                    {
                        method:     "GET",
                        dataType:   "json"
                    })
                    .done(function(response)
                    {
                        _handleVariation(variationId, response.data, store);
                    })
                    .fail(function(err)
                    {
                        context.state.isLoading = false;
                        console.error(err);
                    });
            }

        }
    }
}
